// Persistent storage that survives logout and browser close
const STORAGE_KEY = 'benjamin_madera_persistent_backup';

export const persistentStorage = {
  // Save data permanently
  save(data) {
    try {
      // Save to localStorage
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      
      // Also save to sessionStorage as backup
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      
      console.log('[PersistentStorage] Data saved');
      return true;
    } catch (e) {
      console.error('[PersistentStorage] Save failed:', e);
      return false;
    }
  },

  // Load data from permanent storage
  load() {
    try {
      // Try localStorage first
      let data = localStorage.getItem(STORAGE_KEY);
      if (data) {
        return JSON.parse(data);
      }
      
      // Fallback to sessionStorage
      data = sessionStorage.getItem(STORAGE_KEY);
      if (data) {
        return JSON.parse(data);
      }
      
      return null;
    } catch (e) {
      console.error('[PersistentStorage] Load failed:', e);
      return null;
    }
  },

  // Restore account data to active localStorage
  restore() {
    try {
      const backup = this.load();
      if (!backup) {
        console.log('[PersistentStorage] No backup found');
        return false;
      }

      const { user, resume } = backup;
      
      // Restore user session
      localStorage.setItem('user', JSON.stringify(user));
      
      // Restore user ID mapping
      const userIdByEmail = {};
      userIdByEmail[user.email.toLowerCase()] = user.user_id;
      localStorage.setItem('userIdByEmail', JSON.stringify(userIdByEmail));
      
      // Restore resume
      localStorage.setItem(`resumes_${user.user_id}`, JSON.stringify([resume]));
      
      console.log('[PersistentStorage] Data restored to active storage');
      return true;
    } catch (e) {
      console.error('[PersistentStorage] Restore failed:', e);
      return false;
    }
  },

  // Check if backup exists
  hasBackup() {
    return !!this.load();
  }
};
